import React from "react";
import PredictionPage from "../../components/PredictionPage";

function NaturalGas() {
  return (
    <PredictionPage
      title="Natural Gas"
      content="This is the Natural Gas AI Trading Predictions page."
      canonical="/commodities/natural-gas-ai-trading-predictions"
      categoryKey="nav.commodities"
      categoryPath="/commodities"
      symbol="NATURALGAS"
    />
  );
}

export default NaturalGas;
